// PagePurchaseOrderView Component
/* eslint react/jsx-handler-names:off, indent: off */

import React from 'react'
import async from 'async'
import _ from 'lodash'

import app from '../../../app.jsx'
import eventfilters from '../../../lib/eventfilters.jsx'
import PageBase from '../../../common/page/page_base/page_base.jsx'
import ContentMessage from '../../../common/common/content_message/content_message.jsx'
import PurchaseOrderViewContent from '../../purchaseorder/purchaseorder_viewcontent/purchaseorder_viewcontent.jsx'
import PurchaseOrderViewIntro from '../../purchaseorder/purchaseorder_viewintro/purchaseorder_viewintro.jsx'
import PurchaseOrderAddItem from '../../purchaseorder/purchaseorder_additem/purchaseorder_additem.jsx'
import DialogPurchaseOrderItem from '../../dialog/dialog_purchaseorder_item/dialog_purchaseorder_item.jsx'
import DialogMail from '../../../common/dialog/dialog_email/dialog_email.jsx'
import ExpenseForm from '../../form/expense_form/expense_form.jsx'
import ExpenseUtil from '../../../lib/expenseutil.js'
import DialogPurchaseOrderEdit from '../../dialog/dialog_purchaseorder_edit/dialog_purchaseorder_edit.jsx'
import DialogInvoiceAddress from '../../../invoice/dialog/dialog_invoice_address/dialog_invoice_address.jsx'
import DialogPurchaseOrderOpen from '../../dialog/dialog_purchaseorder_open/dialog_purchaseorder_open.jsx'
import DialogPurchaseOrderComplete from '../../dialog/dialog_purchaseorder_complete/dialog_purchaseorder_complete.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import EmailUtil from '../../../lib/emailutil.js'
import PageHeader from '../../../theme/layout/page_header/page_header.jsx'
import Util from '../../../lib/util.jsx'
import calculate from '../../../lib/calculate.jsx'
import routes from '../../../../shared/routes.js'
import TermsAndConditionText from '../../../common/form/terms_and_conditions/terms_and_conditions.jsx'
import { getTermsAndConditions } from '../../../lib/pdfTemplateUtils'
import { ExpensesIcon } from '../../../common/layout/menu_icons/expenses.jsx'

import { getVatRateSelectOptionsFromArray } from '../../../lib/vat_rates_select_options.js'
import { getVatRatesForCountry } from '../../../../shared/util/vat'

class PagePurchaseOrderView extends PageBase {
  constructor (props) {
    super(props, 'purchaseorder-view', 'expenses', 'purchaseorder-view')

    this.state = {
      dataDate: null,
      addressChecked: false,
      loading: false
    }

    this.data = {
      purchaseorder: null,
      emailSuggestions: [],
      team: app.getTeam(),
      deletedItemId: null,
      updatedItemId: null,
      searchTimer: 0,
      showTermsAndCondition: true,
      termsCleared: false
    }

    this._references = {
      purchaseorderintro: React.createRef(),
      expenseForm: React.createRef(),
      dialogPurchaseOrderItem: React.createRef(),
      refdialogMail: React.createRef(),
      refDialogPurchaseOrderEdit: React.createRef(),
      refDialogInvoiceAddress: React.createRef(),
      refDialogPurchaseOrderOpen: React.createRef(),
      refDialogPurchaseOrderComplete: React.createRef(),
      purchaseorderadd: React.createRef()
    }

    this.showOpen = true

    this._setFABButtonState(true, true)
    this._initRealTimeVariables()
    this._updateItemTime = null
    this._bUnMounted = false
    this._bReloadTotal = false
  }

  componentDidMount () {
    this._getData(false)
    this._initEvents()

    /* Load quickbook options for expense */
    ExpenseUtil.initQuickbookItems()
  }

  componentWillUnmount () {
    this._bUnMounted = true
    this._releaseEvents()
  }

  renderContent () {
    const vatLevels =
      this.data.team && this.data.team.profile
        ? getVatRateSelectOptionsFromArray(getVatRatesForCountry(this.data.team.profile.country))
        : []
    let bDisable = false
    const purchaseorder = this.data.purchaseorder
    if (purchaseorder && purchaseorder.status !== 'Draft') {
      bDisable = true
    }
    const pdfFileName = purchaseorder
      ? Util.getPdfFileName(
          'purchaseorder',
          purchaseorder.invoiceNo,
          purchaseorder.status
        )
      : ''
    const downloadUrl = `${routes.PURCHASEORDER_PREVIEW}/${app.getTeamId()}/${app.loggedInId}/${purchaseorder ? purchaseorder.id : ''}/${pdfFileName}`

    return (
      <div className='pageinnercont'>
        <PurchaseOrderViewIntro
          ref={this._references.purchaseorderintro}
          purchaseOrder={this.data.purchaseorder}
          onChange={this._onIntroChange.bind(this)}
          onDelete={this._onDeleteIntro.bind(this)}
          disableEdit={bDisable}
        />
        {this._renderViewContent()}
        {this._renderMessage()}
        {this._renderAddItem()}
        <ExpenseForm
          ref={this._references.expenseForm}
          onSubmit={this._onSubmitExpense.bind(this)}
          contactsearch={this._onSearchContact.bind(this)}
          onValidateInvoiceNo={ExpenseUtil.validateInvoiceNo}
          showError={this.showError.bind(this)}
          getProjects={ExpenseUtil.getProjects}
          getContactBudgetItems={ExpenseUtil.getContactBudgetItems}
          onAddBudgetExpense={ExpenseUtil.onAddBudgetExpense}
          onSelectBudgetExpense={ExpenseUtil.onSelectBudgetExpense}
          onSearchBudgetItem={ExpenseUtil.getProjectBudgetItems}
          onClose={this._onCloseForm.bind(this)}
          onCreateContact={ExpenseUtil.onCreateContact}
          attachment={this.data.team.integration.isAttached}
          validateExpenseTotalWithPO={ExpenseUtil.validateExpenseTotalWithPO}
          vatLevels={vatLevels}
          defaultVat={app.getDefaultVat()}
          showVat={app.isVatSupportedInCountry(app.teamCountry)}
          isQuickbookConnected={app.isQuickbookConnected()}
          getQuickbookItems={ExpenseUtil.getQuickbookItems}
          reloadQuickbookItems={ExpenseUtil.reloadQuickbookItems}
        />
        {this._renderTermsAndCondition()}
        <DialogPurchaseOrderItem
          ref={this._references.dialogPurchaseOrderItem}
          onSubmit={this._onAddItemSubmit.bind(this)}
        />
        <DialogMail
          ref={this._references.refdialogMail}
          onSubmit={this._onSubmitMail.bind(this)}
          isLoading={this.state.loading}
          onDownload={this._onDownloadMailInvoice.bind(this)}
          mailSuggestions={this.data.emailSuggestions}
          showMultiAttachments
          showLanguage={app.teamCountry === 'NL' || app.teamCountry === 'DE'}
        />
        <DialogPurchaseOrderEdit
          ref={this._references.refDialogPurchaseOrderEdit}
          onSubmit={this._onSubmitPurchaseOrderEdit.bind(this)}
          onDelete={this._onDeletePurchaseOrder.bind(this)}
          showLanguage={app.teamCountry !== 'US'}
        />
        <DialogInvoiceAddress
          ref={this._references.refDialogInvoiceAddress}
          message='expense.form.contactInfo'
          isAddressForPO
          teamCountry={app.teamCountry}
          onSubmit={this._onSubmitAddressPurchaseOrder.bind(this)}
        />
        <DialogPurchaseOrderOpen
          ref={this._references.refDialogPurchaseOrderOpen}
          onSubmit={this._onSubmitOpen.bind(this)}
          onEditAddress={this._onEditAddress.bind(this)}
          setAddressNotChecked={this.setAddressNotChecked.bind(this)}
        />
        <DialogPurchaseOrderComplete
          ref={this._references.refDialogPurchaseOrderComplete}
          downloadUrl={downloadUrl}
          onMail={this._onMailOpenPo.bind(this)}
        />
      </div>
    )
  }

  getContentClassname () {
    return 'full'
  }

  _onSubmitAddressPurchaseOrder (updateObj, addressChecked) {
    const purchaseorder = this.data.purchaseorder
    const contactAddresses = []
    let bUpdateExistingCont = false

    if (purchaseorder.contactAddress !== undefined) {
      purchaseorder.contact.addresses.map(address => {
        if (address.type === purchaseorder.contactAddress.type) {
          bUpdateExistingCont = true
          address.street = updateObj.address.street
            ? updateObj.address.street
            : address.street
          address.postcode = updateObj.address.postcode
            ? updateObj.address.postcode
            : address.postcode
          address.city = updateObj.address.city
            ? updateObj.address.city
            : address.city
          address.state = updateObj.address.state
            ? updateObj.address.state
            : address.state
          address.country = updateObj.address.country
            ? updateObj.address.country
            : address.country
          address.type = address.type ? address.type : 'Po'
        }
        contactAddresses.push(address)
      })
    }

    const address = {
      street: updateObj.address.street,
      postcode: updateObj.address.postcode,
      city: updateObj.address.city,
      state: updateObj.address.state,
      country: updateObj.address.country,
      type: updateObj.address.type ? updateObj.address.type : 'Po',
      streetNumber: updateObj.address.streetNumber
    }

    const contObj = {
      company: updateObj.company,
      addresses:
        bUpdateExistingCont && contactAddresses && contactAddresses.length > 0
          ? contactAddresses
          : [address],
      vatNo: updateObj.vatNo
    }

    if (updateObj.contactPersons && updateObj.contactPersons.length > 0) {
      contObj.contactPersons = updateObj.contactPersons
    }

    async.series(
      [
        done => {
          this._updateContactAddresses(contObj, done)
        },
        done => {
          this._updatePurchaseOrderContact(updateObj, done)
        }
      ],
      (err, _res) => {
        if (err) {
          if (this._references.refDialogInvoiceAddress.current) {
            this._references.refDialogInvoiceAddress.current.showError()
          }
          app.debug(
            'PagepurchaseOrderView: _onSubmitAddressPurchaseOrder err',
            err
          )
        } else {
          if (this.showOpen) {
            if (this._references.refDialogPurchaseOrderOpen.current) {
              this._references.refDialogPurchaseOrderOpen.current.hide()
            }
            this._getDataPurchaseOrder(_res => {
              this._onOpen()
            })
          } else {
            this._reloadData()
          }

          if (this._references.refDialogInvoiceAddress.current) {
            this._references.refDialogInvoiceAddress.current.hide()
          }
        }
      }
    )
    this.setState({ addressChecked: addressChecked })
  }

  setAddressNotChecked (addressChecked) {
    this.setState({ addressChecked: addressChecked })
  }

  /* Private functions */
  _updateContactAddresses (contactObj, callback) {
    app
      .service('/api/contact')
      .patch(this.data.purchaseorder.contactId, contactObj)
      .then(_contRes => {
        callback(null)
      })
      .catch(contUpdateErr => {
        app.debug(
          'PagepurchaseOrderView: _updateContactAddresses err',
          contUpdateErr
        )
        callback(contUpdateErr)
      })
  }

  _updatePurchaseOrderContact (updateObj, callback) {
    const purchaseorderObj = {
      contactAddress: updateObj.address
    }

    if (updateObj.selectedContactPerson) {
      purchaseorderObj.contactPerson = updateObj.selectedContactPerson
    }

    app
      .service('/api/purchaseorder')
      .patch(this.data.purchaseorder.id, purchaseorderObj)
      .then(_decRes => {
        callback(null)
      })
      .catch(estUpdateErr => {
        app.debug(
          'PagepurchaseOrderView: _updatePurchaseOrderContactAddresses err',
          estUpdateErr
        )
        callback(estUpdateErr)
      })
  }

  /* Event handlers */
  _onSubmitPurchaseOrderEdit (purchaseOrderObj) {
    const purchaseorder = this.data.purchaseorder
    app
      .service('/api/purchaseorder')
      .patch(purchaseorder.id, purchaseOrderObj)
      .then(_estRes => {
        this._reloadData()

        if (this._references.refDialogPurchaseOrderEdit.current) {
          this._references.refDialogPurchaseOrderEdit.current.hide()
        }
      })
      .catch(estErr => {
        app.debug(
          'PagepurchaseOrderView: _onSubmitPurchaseOrderEdit err',
          estErr
        )
      })
  }

  _onEdit (event) {
    event.preventDefault()
    const purchaseorder = this.data.purchaseorder
    const contact = purchaseorder.contact
    const contactAddresses =
      purchaseorder && contact && contact.addresses ? contact.addresses : null
    const params = {}
    const contactPersonOptions = this._getContactPersonOptions(contact)

    if (purchaseorder) {
      app
        .service('/api/contact')
        .get(purchaseorder.contactId, params)
        .then(result => {
          if (result) {
            const purObj = {
              contactLabel: contact ? contact.company : '',
              addressOptions: this._getContactAddressOptions(purchaseorder),
              addresses: contactAddresses,
              contactPersonOptions: contactPersonOptions,
              contactPerson: this._getContactPersonOrDefault(
                purchaseorder,
                contactPersonOptions
              ),
              contactAddress:
                purchaseorder.contactAddress &&
                purchaseorder.contactAddress.type
                  ? purchaseorder.contactAddress
                  : contactAddresses
                  ? contactAddresses[0]
                  : null,
              pdfLanguage: calculate.getFileLanguage(
                purchaseorder,
                purchaseorder.contact,
                app.getTeam()
              )
            }

            if (this._references.refDialogPurchaseOrderEdit.current) {
              this._references.refDialogPurchaseOrderEdit.current.show(purObj)
            }
          }
        })
        .catch(err => {
          app.debug('PagepurchaseOrderView: _onEdit err', err)
        })
    }
  }

  _getContactPersonOptions (contact) {
    const contactPersonOptions = []
    if (
      contact &&
      contact.contactPersons &&
      contact.contactPersons.length > 0
    ) {
      contact.contactPersons.map(contactPerson => {
        const label =
          contactPerson.name +
          (contactPerson.email ? ' - ' + contactPerson.email : '')
        contactPersonOptions.push({
          label: label,
          value: label,
          obj: contactPerson
        })
      })
    }

    return contactPersonOptions
  }

  _getContactPersonOrDefault (invoice, contactPersons) {
    let contactPersonIdent = ''
    if (invoice.contactPerson) {
      contactPersonIdent = `${invoice.contactPerson.name}${
        invoice.contactPerson.email ? ' - ' + invoice.contactPerson.email : ''
      }`
    } else if (contactPersons.length > 0) {
      contactPersonIdent = contactPersons[0].value
    }

    return contactPersonIdent
  }

  _getContactAddressOptions (purchaseorder) {
    const addressOptions = []
    const contact = purchaseorder.contact
    if (contact && contact.addresses && contact.addresses.length > 0) {
      contact.addresses.map(address => {
        const existTypeOption = _.find(
          addressOptions,
          addressOption => addressOption.label === address.type
        )
        const label = IntlUtil.convertMessage(
          `contact.view.type${address.type}`
        )
        if (existTypeOption === undefined) {
          addressOptions.push({
            label: label,
            value: address.type.toLowerCase()
          })
        }
      })
    }

    if (purchaseorder.contactAddress && addressOptions[0].value === undefined) {
      const label = IntlUtil.convertMessage(
        `contact.view.type${purchaseorder.contactAddress.type}`
      )
      addressOptions.push({
        label: label,
        value: purchaseorder.contactAddress.type.toLowerCase()
      })
    }

    return addressOptions
  }

  _onChangeStatus () {
    const status = this.data.purchaseorder.status === 'Open' ? 'Closed' : 'Open'

    if (this.data.purchaseorder.status === 'Draft') {
      this._onOpen()
    } else {
      this._updateStatus(status)
    }
  }

  _onOpen () {
    const purchaseorder = this.data.purchaseorder
    const contactPersonOptions = this._getContactPersonOptions(
      purchaseorder.contact
    )

      this.showOpen = true
      const contObj = {
        contactName: purchaseorder.contact.company,
        address: purchaseorder.contactAddress,
        vatNo: purchaseorder.contact.vatNo,
        contactPersonOptions: contactPersonOptions,
        contactPerson: this._getContactPersonOrDefault(
          purchaseorder,
          contactPersonOptions
        )
      }

      if (this._references.refDialogInvoiceAddress.current) {
        this._references.refDialogInvoiceAddress.current.show(contObj, true)
      }
     if (this.state.addressChecked) {
      this._references.refDialogInvoiceAddress.current.hide()
      const obj = {
        total: purchaseorder.total,
        contactName: purchaseorder.contact.company,
        addressOptions: this._getContactAddressOptions(purchaseorder),
        addresses:
          purchaseorder &&
          purchaseorder.contact &&
          purchaseorder.contact.addresses
            ? purchaseorder.contact.addresses
            : null,
        contactPersonOptions: contactPersonOptions,
        contactPerson: this._getContactPersonOrDefault(
          purchaseorder,
          contactPersonOptions
        ),
        contactAddress: purchaseorder.contactAddress
          ? purchaseorder.contactAddress
          : ''
      }

      if (this._references.refDialogPurchaseOrderOpen.current) {
        this._references.refDialogPurchaseOrderOpen.current.show(obj)
      }
    }
  }

  _updateStatus (status) {
    app
      .service('/api/purchaseorder')
      .patch(this.props.purchaseOrderId, { status: status })
      .then(_updateRes => {
        this._reloadData()
      })
      .catch(updateErr => {
        app.debug('PagePurchaseOrderView _updateStatus updateErr', updateErr)
      })
  }

  _onSubmitOpen (poObj) {
    app
      .service('/api/purchaseorder')
      .patch(this.props.purchaseOrderId, poObj)
      .then(opnRes => {
        if (this._references.refDialogPurchaseOrderOpen.current) {
          this._references.refDialogPurchaseOrderOpen.current.hide()
        }

        if (this._references.refDialogPurchaseOrderComplete.current) {
          this._references.refDialogPurchaseOrderComplete.current.show(
            opnRes && opnRes.invoiceNo ? opnRes.invoiceNo : ''
          )
        }
      })
      .catch(opnErr => {
        app.debug('PagePurchaseOrderView: _onSubmitOpen err', opnErr)
      })
  }

  _onEditAddress (e) {
    e.preventDefault()
    const purchaseorder = this.data.purchaseorder
    const contactPersonOptions = this._getContactPersonOptions(
      purchaseorder.contact
    )

    if (purchaseorder) {
      const contObj = {
        contactName: purchaseorder.contact.company,
        address: purchaseorder.contact.address,
        vatNo: purchaseorder.contact.vatNo,
        contactPersonOptions: contactPersonOptions,
        contactPerson: this._getContactPersonOrDefault(
          purchaseorder,
          contactPersonOptions
        )
      }

      if (this._references.refDialogInvoiceAddress.current) {
        this._references.refDialogInvoiceAddress.current.show(contObj, true)
      }
    }
  }

  _onMailOpenPo (_bFullDetails) {
    if (this._references.refDialogPurchaseOrderOpen.current) {
      this._references.refDialogPurchaseOrderOpen.current.hide()
    }

    if (this._references.refDialogPurchaseOrderComplete.current) {
      this._references.refDialogPurchaseOrderComplete.current.hide()
    }
    this._showEmailDialog()
  }

  _showEmailDialog () {
    app.debug('### PagePurchaseOrderView - _showEmailDialog')
    const params = { query: {} }
    app
      .service('/api/purchaseorder/mail')
      .get(this.data.purchaseorder.id, params)
      .then(result => {
        if (result) {
          if (this._references.refdialogMail.current) {
            this._references.refdialogMail.current.show(result)
          }
        }
      })
      .catch(err => {
        app.debug('PagePurchaseOrderView: _showEmailDialog err', err)
      })
  }

  _onDeletePurchaseOrder () {
    if (!this.data.purchaseorder.id) {
      return false
    }

    this._bUnMounted = true
    app
      .service('/api/purchaseorder')
      .remove(this.data.purchaseorder.id)
      .then(_deleteRes => {
        if (this._references.refDialogPurchaseOrderEdit.current) {
          this._references.refDialogPurchaseOrderEdit.current.hide()
        }
        app.changePage('purchaseorders')
      })
      .catch(deleteErr => {
        app.debug('PagePurchaseOrderView _onDeletePurchaseOrder err', deleteErr)
      })
  }

  onAdd () {
    if (this._references.purchaseorderadd.current) {
      this._references.purchaseorderadd.current.show()
    }
  }

  onFABClose () {
    if (this._references.purchaseorderadd.current) {
      this._references.purchaseorderadd.current.hide()
    }
  }

  _onIntroAdd (ev) {
    ev.preventDefault()

    if (this.data.purchaseorder.introText === null) {
      this.data.purchaseorder.introText = ''
    }

    if (this._references.purchaseorderintro.current) {
      this._references.purchaseorderintro.current.show(true)
    }
  }

  _getBudgetItems (callback) {
    const purchaseorder = this.data.purchaseorder
    const itemParams = {
      query: {
        contactId: purchaseorder.contactId,
        projectId: purchaseorder.projectId
      }
    }

    app
      .service('/api/purchaseorder/item')
      .find(itemParams)
      .then(itemRes => {
        const supplierParams = {
          query: {
            contactId: purchaseorder.contactId,
            projectId: purchaseorder.projectId,
            $client: {
              subObjects: {
                budgetItem: ['title', 'total', 'description']
              }
            }
          }
        }

        if (itemRes.data && itemRes.data.length > 0) {
          supplierParams.query._id = {
            $nin: itemRes.data.map(obj => obj.budgetItemSupplierId)
          }
        }

        app
          .service('/api/project/budgetitemsupplier')
          .find(supplierParams)
          .then(supplierRes => {
            const budgetItems = []
            supplierRes.data.map(itemSupplier => {
              budgetItems.push({
                label: itemSupplier.budgetItem.title,
                value: itemSupplier.budgetItemId,
                itemSupplierId: itemSupplier.id,
                total: itemSupplier.budgetItem.total,
                description: itemSupplier.budgetItem.description
              })
            })

            callback(budgetItems)
          })
          .catch(err => {
            app.debug('PagePurchaseOrderView: _getBudgetItems Error', err)
            callback([]) // eslint-disable-line standard/no-callback-literal
          })
      })
  }

  _onAddItem (ev) {
    ev.preventDefault()

    if (this._references.purchaseorderadd.current) {
      this._references.purchaseorderadd.current.hide()
    }
    this._getBudgetItems(options => {
      if (this._references.dialogPurchaseOrderItem.current) {
        this._references.dialogPurchaseOrderItem.current.show(options)
      }
    })
  }

  _onAddItemSubmit (expenseItem) {
    if (this._references.dialogPurchaseOrderItem.current) {
      this._references.dialogPurchaseOrderItem.current.hide()
    }

    const purchaseOrder = this.data.purchaseorder
    const createObj = {
      purchaseOrderId: purchaseOrder.id,
      projectId: purchaseOrder.projectId,
      contactId: purchaseOrder.contactId,
      budgetItemId: expenseItem.value,
      budgetItemSupplierId: expenseItem.itemSupplierId,
      title: expenseItem.label,
      description: expenseItem.description ? expenseItem.description : '',
      total: expenseItem.total
    }

    app
      .service('/api/purchaseorder/item')
      .create(createObj)
      .then(createItemRes => {
        if (!this.data.purchaseorder.items) {
          this.data.purchaseorder.items = []
        }

        this.data.purchaseorder.items.push(createItemRes)
        this._onUpdatePurchaseOrderTotal()
      })
      .catch(createItemErr => {
        app.debug('PagePurchaseOrderView: _onAddItemSubmit err', createItemErr)
      })
  }

  _onDeleteIntro () {
    if (this.data.purchaseorder !== null) {
      this.data.purchaseorder.introText = null
      this._onIntroChange(null)
    }

    if (this._references.purchaseorderintro.current) {
      this._references.purchaseorderintro.current.hide()
    }
  }

  _onIntroChange (introText) {
    const updateObj = { introText: introText || null }

    app
      .service('/api/purchaseorder')
      .patch(this.data.purchaseorder.id, updateObj)
      .then(_introRes => {
        this._refresh()
      })
      .catch(introErr => {
        app.debug('PagePurchaseOrderView: _onIntroChange err', introErr)
      })
  }

  _onUpdateItem (item, bUpdateTotal, fields = []) {
    if (bUpdateTotal) {
      this._onUpdateItemTotal(item)
    } else if (fields && fields.length > 0) {
      this._onUpdateItemInfo(item, fields)
    }
  }

  _onUpdateItemTotal (item) {
    const updateObj = { total: item.total }
    if (this._updateItemTime) window.clearTimeout(this._updateItemTime)

    this._updateItemTime = window.setTimeout(() => {
      app
        .service('/api/purchaseorder/item')
        .patch(item.id, updateObj)
        .then(_updateItemRes => {
          this.data.updatedItemId = item.id
          this._onUpdatePurchaseOrderTotal()
        })
        .catch(updateItemErr => {
          app.debug(
            'PagePurchaseOrderView: _onUpdateItemTotal err',
            updateItemErr
          )
        })
    }, 1000)
  }

  _onUpdateItemInfo (item, fields) {
    const updateObj = {}
    fields.forEach(key => {
      updateObj[key] = item[key]
    })

    app
      .service('/api/purchaseorder/item')
      .patch(item.id, updateObj)
      .then(_updateItemRes => {
        this._reloadData()
      })
      .catch(updateItemErr => {
        app.debug('PagePurchaseOrderView: _onUpdateItemInfo err', updateItemErr)
      })
  }

  _onDeleteItem (delItem) {
    if (!delItem.id) {
      return false
    }

    app
      .service('/api/purchaseorder/item')
      .remove(delItem.id)
      .then(_delItemRes => {
        this.data.deletedItemId = delItem.id
        _.remove(this.data.purchaseorder.items, item => item.id === delItem.id)
        this._onUpdatePurchaseOrderTotal()
      })
      .catch(delItemErr => {
        app.debug('PagePurchaseOrderView: _onDeleteItem err', delItemErr)
      })
  }

  _onUpdatePurchaseOrderTotal () {
    const updateObj = { total: 0 }
    if (
      this.data.purchaseorder.items &&
      this.data.purchaseorder.items.length > 0
    ) {
      updateObj.total = _.sumBy(this.data.purchaseorder.items, item => {
        return parseFloat(item.total)
      })
    }

    this._bReloadTotal = true

    app
      .service('/api/purchaseorder')
      .patch(this.data.purchaseorder.id, updateObj)
      .then(_updateTotalRes => {})
      .catch(updateTotalErr => {
        app.debug(
          'PagePurchaseOrderView: _onUpdatePurchaseOrderTotal err',
          updateTotalErr
        )
      })

    this.data.purchaseorder.total = updateObj.total
    this._refresh()
  }

  _onSubmitMail (mailObj) {
    this.setState({ loading: true })
    app.debug('PagePurchaseOrderView: _onSubmitMail [Start]')

    EmailUtil.sendPurchaseOrdeMail(mailObj, this.data.purchaseorder)
      .then(_result => {
        if (this._references.refdialogMail.current) {
          this._references.refdialogMail.current.hide()
        }
        this.setState({ loading: false })
      })
      .catch(err => {
        app.debug('PagePurchaseOrderView: _onSubmitMail err', err)
      })
  }

  _onDownloadMailInvoice (_invoiceId) {}

  _onSendMail (event) {
    event.preventDefault()
    app.debug('### PagePurchaseOrderView - _onSendMail')
    const params = { query: {} }
    app
      .service('/api/purchaseorder/mail')
      .get(this.data.purchaseorder.id, params)
      .then(result => {
        if (result) {
          if (this._references.refdialogMail.current) {
            this._references.refdialogMail.current.show(result)
          }
        }
      })
      .catch(err => {
        app.debug('PagePurchaseOrderView: _onSendMail err', err)
      })
  }

  _onDownload () {
    const teamId = app.getTeamId()
    if (this.data.purchaseorder) {
      const createObj = {
        purchaseOrderId: this.data.purchaseorder.id
      }

      app
        .service('/api/purchaseorder/pdf')
        .create(createObj, {})
        .then(pdfRes => {
          app.redirect(
            encodeURI(`/purchaseorder/download/${teamId}/${pdfRes.pdfName}`)
          )
        })
        .catch(pdfErr => {
          app.debug('PagePurchaseOrder: _onClickDownload', pdfErr)
        })
    }
  }

  _onAddPurchaseInvoice () {
    ExpenseUtil.createExpenseDataFromPO(
      this.data.purchaseorder,
      (expense, items) => {
        if (this._references.expenseForm.current) {
          this._references.expenseForm.current.show(expense, false, items)
        }
      }
    )
  }

  _getData (bReload) {
    this._setDataLoading()

    const params = {
      query: {
        bUpdatePageState: bReload,
        pageState: this.data.pageState,
        pageIdent: this._pageIdent,
        purchaseOrderId: this.props.purchaseOrderId,
        purchaseorder: {
          $client: {
            subObjects: {
              contact: [
                'company',
                'addresses',
                'contactPersons',
                'pdfLanguage',
                'vatNo'
              ],
              project: ['title', 'projectNumber'],
              items: []
            }
          }
        }
      }
    }

    app
      .service('/api/page/purchaseorder/view')
      .find(params)
      .then(async (result) => {
        if (result) {
          if (result.purchaseorder) {
            this.data.purchaseorder = result.purchaseorder
            if (!this.data.purchaseorder.termsAndCondition && !this.data.termsCleared) {
              this.data.purchaseorder.termsAndCondition = await getTermsAndConditions(
                app.getTeamId(),
                'purchaseorder'
              )

              const updateObj = {
                termsAndCondition: this.data.purchaseorder.termsAndCondition
              }

              app
                .service('/api/purchaseorder')
                .patch(this.data.purchaseorder.id, updateObj)
                .then(_termsRes => {
                  this._refresh()
                })
                .catch(err => {
                  app.debug('PagePurchaseOrderView: _getData err', err)
                })
            }
          }
          if (result.emailSuggestions) {
            this.data.emailSuggestions = result.emailSuggestions
          }
        }
        this._onDataReceived(null)
      })
      .catch(err => {
        this._onDataReceived(err)
      })
  }

  /* _getData() {
    async.series([
      (done) => {
        this._getPageData(done);
      },
      (done) => {
        this._getDataPurchaseOrder(done);
      }
    ], (asyncErr, _asyncRes) => {
      this._onDataReceived(asyncErr);
    });
  } */

  _getDataPurchaseOrder (callback) {
    const params = {
      query: {
        $client: {
          subObjects: {
            contact: ['company', 'addresses', 'contactPersons', 'pdfLanguage'],
            project: ['title'],
            items: []
          }
        }
      }
    }

    app
      .service('/api/purchaseorder')
      .get(this.props.purchaseOrderId, params)
      .then(purOrderRes => {
        if (purOrderRes) {
          this.data.purchaseorder = purOrderRes
        }

        if (
          this.data.purchaseorder &&
          this.data.purchaseorder.contact.contactPersons &&
          this.data.purchaseorder.contact.contactPersons.length > 0
        ) {
          const persons = this.data.purchaseorder.contact.contactPersons
          const tagsData = _.uniqBy(persons, person => person.email)
          const tags = tagsData.map((tagObj, _idx) => {
            let mailOption = `${tagObj.email} (${tagObj.name})`

            if (!tagObj.name) {
              mailOption = `${tagObj.email}`
            }

            tagObj.key = mailOption

            return mailOption
          })

          this.data.emailSuggestions = tags
        }

        callback(null)
      })
      .catch(purOrderErr => {
        app.debug(
          'PagePurchaseOrderView: _getDataPurchaseOrder err',
          purOrderErr
        )
        callback(purOrderErr)
      })
  }

  _reloadData () {
    if (this._bUnMounted) return

    this._getData(true)
  }

  _refresh () {
    this.setState({ dataDate: new Date() })
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    this._setDataLoaded()

    if (err) {
      app.debug('PagePurchaseOrderView: _onDataReceived Error', err)
      this._setFABButtonVisible(false)
      this._refresh()
    } else {
      app.debug('PagePurchaseOrderView: _onDataReceived [done]')

      if (
        this.data.purchaseorder &&
        this.data.purchaseorder.status === 'Draft'
      ) {
        this._setFABButtonVisible(true)
      } else {
        this._setFABButtonVisible(false)
      }

      this.showOpen = true

      /** ROD-3714 const purchaseorder = this.data.purchaseorder;
      if (purchaseorder && purchaseorder.contact) {
        if (purchaseorder.contactAddress === undefined || (purchaseorder.contactAddress !== undefined &&
          (!purchaseorder.contactAddress.street || !purchaseorder.contactAddress.city ||
          !purchaseorder.contactAddress.postcode))) {
          this.showOpen = false;
          const contObj = {
            contactName: purchaseorder.contact.company,
            address: purchaseorder.contactAddress,
            vatNo: purchaseorder.contact.vatNo
          };

          this._references.refDialogInvoiceAddress.current.show(contObj, true);
        }
      } **/

      this._refresh()
    }
  }

  _onSearchContact (keyword, callback) {
    this._onCommonFilterContactSearch(keyword, callback)
  }

  _onSubmitExpense (
    expenseObj,
    expenseId,
    items,
    deletedItemIds,
    fileObj,
    bDeleteFile,
    closePoIds,
    newContactData,
    callback
  ) {
    expenseObj.createdById = app.loggedInId
    const bSendQuickbook = expenseObj.bSendQuickbook

    if (expenseId) {
      ExpenseUtil.updateExpense(
        expenseObj,
        expenseId,
        items,
        deletedItemIds,
        fileObj,
        bDeleteFile,
        closePoIds,
        newContactData,
        updateErr => {
          if (updateErr) {
            app.debug('PagePurchaseOrder updateErr', updateErr)
            if (updateErr.message === 'Invoice number already exists') {
              this.showError('expense.list.errorInvoiceNoAlreadyExists')
            } else if (updateErr.code >= 501 || updateErr.code <= 510) {
              this.showError(`expense.list.errorMsg${updateErr.code}`)
            } else {
              this.showError('expense.list.errorUpdateMsg')
            }
            callback(updateErr)
          } else {
            this._onAfterSave(false, bSendQuickbook, null, callback)
          }
        }
      )
    } else {
      ExpenseUtil.createExpense(
        expenseObj,
        items,
        deletedItemIds,
        fileObj,
        bDeleteFile,
        closePoIds,
        newContactData,
        (createErr, createRes) => {
          if (createErr) {
            app.debug('PagePurchaseOrder createErr', createErr)
            if (createErr.message === 'Invoice number already exists') {
              this.showError('expense.list.errorInvoiceNoAlreadyExists')
            } else if (createErr.code >= 501 || createErr.code <= 510) {
              this.showError(`expense.list.errorMsg${createErr.code}`)
            } else {
              this.showError('expense.list.errorCreateMsg')
            }
            callback(createErr)
          } else {
            this._onAfterSave(true, bSendQuickbook, createRes.expense, callback)
          }
        }
      )
    }
  }

  _onAfterSave (bCreateExpense, bSendQuickbook, expense, callback) {
    // If Quickbooks is not connected, close the form immediately
    // If expense is already sent to Quickbooks, close the form immediately
    if (!app.isQuickbookConnected() || !bSendQuickbook) {
      callback(null)

      if (this._references.expenseForm.current) {
        this._references.expenseForm.current.hide(false)
      }

      this._reloadData()
    } else {
      // If Quickbooks is connected, open form in edit mode,
      // and wait until the Quickbooks response comes
      if (bCreateExpense) {
        if (expense && expense.id) {
          ExpenseUtil.getExpenseDetails(expense.id, (expenseObj, items) => {
            if (expenseObj) {
              if (this._references.expenseForm.current) {
                this._references.expenseForm.current.show(
                  expenseObj,
                  true,
                  items
                )
              }
            }
          })
        }
      }
    }
  }

  _onCloseForm () {
    if (this._references.expenseForm.current) {
      this._references.expenseForm.current.hide()
    }
  }

  /* Private functions */
  _renderViewContent () {
    if (
      this.data.purchaseorder &&
      this.data.purchaseorder.items &&
      this.data.purchaseorder.items.length > 0
    ) {
      return (
        <PurchaseOrderViewContent
          purchaseorder={this.data.purchaseorder}
          onUpdateItem={this._onUpdateItem.bind(this)}
          onDeleteItem={this._onDeleteItem.bind(this)}
        />
      )
    }

    return ''
  }

  _renderMessage () {
    if (
      this.data.purchaseorder &&
      this.data.purchaseorder.items &&
      this.data.purchaseorder.items.length > 0
    ) {
      return ''
    }

    return (
      <ContentMessage
        message='expense.view.emptyPoMsg'
        info='expense.view.emptyPoInfo'
        showAddPrefix
        showAdd={false}
      />
    )
  }

  _renderAddItem () {
    if (this.data.purchaseorder?.status !== 'Draft') {
      return null
    }

    return (
      <PurchaseOrderAddItem
        ref={this._references.purchaseorderadd}
        onClose={e => this._onFABPurchaseViewAddClose(e)}
        onIntroAdd={e => this._onIntroAdd(e)}
        onAddTermsAndCondition={e => this._onAddTermsAndCondition(e)}
      />
    )
  }

  _onFABPurchaseViewAddClose () {
    this._hideCloseFABButton()
  }

  async _onAddTermsAndCondition () {
    this.data.showTermsAndCondition = true

    if (!this.data.purchaseorder.termsAndCondition) {
      this.data.purchaseorder.termsAndCondition = await getTermsAndConditions(app.getTeamId(), 'purchaseorder')

      this.setState({ dataDate: new Date() })

      // Update terms and conditions
      if (this.data.purchaseorder.termsAndCondition) {
        const updateObj = {
          termsAndCondition: this.data.purchaseorder.termsAndCondition
        }

        app
        .service('/api/purchaseorder')
        .patch(this.data.purchaseorder.id, updateObj)
        .then(_termsRes => {
          this._refresh()
        })
        .catch(err => {
          app.debug('PagePurchaseOrderView: _onAddTermsAndCondition err', err)
        })
      }
    }
  }

  _renderTermsAndCondition () {
    const { showTermsAndCondition, purchaseorder } = this.data
    if (!showTermsAndCondition || !purchaseorder) {
      return null
    }
    return <TermsAndConditionText
      text={purchaseorder.termsAndCondition}
      onChange={this.handleOnChangeTermsAndConditon}
      onBlur={this.handleOnBlurTermsAndConditon}
      onDelete={this.handleOnDeleteTermsAndCondition}
           />
  }

  handleOnChangeTermsAndConditon = value => {
    this.data.purchaseorder.termsAndCondition = value
    if (value === '') {
      this.data.termsCleared = true
    }
    this.setState({ dataDate: new Date() })
  }

  handleOnBlurTermsAndConditon = () => {
    const updateObj = {
      termsAndCondition: this.data.purchaseorder.termsAndCondition
    }

    app
      .service('/api/purchaseorder')
      .patch(this.data.purchaseorder.id, updateObj)
      .then(_termsRes => {
        this._refresh()
      })
      .catch(err => {
        app.debug('PagePurchaseOrderView: handleOnBlurTermsAndConditon err', err)
      })
  }

  handleOnDeleteTermsAndCondition = () => {
    this.data.termsCleared = true
    const updateObj = {
      termsAndCondition: ''
    }

    app
      .service('/api/purchaseorder')
      .patch(this.data.purchaseorder.id, updateObj)
      .then(_termsRes => {
        this.data.showTermsAndCondition = false
        this._refresh()
      })
      .catch(err => {
        app.debug('PagePurchaseOrderView: handleOnBlurTermsAndConditon err', err)
      })
  }

  /* Realtime Events */
  _initEvents () {
    this._eventHandlers.purchaseOrderPatched = this._eventReload.bind(
      this,
      'Purchase Order',
      'Patched'
    )
    this._eventHandlers.purchaseOrderItemCreated = this._eventReload.bind(
      this,
      'Purchase Order Item',
      'Created'
    )
    this._eventHandlers.purchaseOrderItemRemoved = this._eventReload.bind(
      this,
      'Purchase Order Item',
      'Removed'
    )
    this._eventHandlers.purchaseOrderItemPatched = this._eventReload.bind(
      this,
      'Purchase Order Item',
      'Patched'
    )

    const purchaseOrderService = app.service('/api/purchaseorder')
    purchaseOrderService.on('patched', this._eventHandlers.purchaseOrderPatched)

    const purchaseOrderItemService = app.service('/api/purchaseorder/item')
    purchaseOrderItemService.on(
      'created',
      this._eventHandlers.purchaseOrderItemCreated
    )
    purchaseOrderItemService.on(
      'removed',
      this._eventHandlers.purchaseOrderItemRemoved
    )
    purchaseOrderItemService.on(
      'patched',
      this._eventHandlers.purchaseOrderItemPatched
    )

    /* Init quickbook events */
    this._initQuickbookExpenseEvents()
  }

  _eventReload (objectName, eventName, eventData) {
    if (
      (this._canRealTimeReload() || this._bReloadTotal) &&
      eventfilters.teamFilter(eventData)
    ) {
      app.debug(
        `-- Event - PagePurchaseOrderView - ${objectName} - ${eventName} --`
      )

      // reload if the item is not updated by us
      if (
        eventData.id === this.data.deletedItemId ||
        eventData.id === this.data.updatedItemId
      ) {
        this.data.deletedItemId = null
        this.data.updatedItemId = null
      } else {
        this._bReloadTotal = false
        this._reloadData()
      }
    }
  }

  _releaseEvents () {
    const purchaseOrderService = app.service('/api/purchaseorder')
    purchaseOrderService.off(
      'patched',
      this._eventHandlers.purchaseOrderPatched
    )

    const purchaseOrderItemService = app.service('/api/purchaseorder/item')
    purchaseOrderItemService.off(
      'created',
      this._eventHandlers.purchaseOrderItemCreated
    )
    purchaseOrderItemService.off(
      'removed',
      this._eventHandlers.purchaseOrderItemRemoved
    )
    purchaseOrderItemService.off(
      'patched',
      this._eventHandlers.purchaseOrderItemPatched
    )

    this._eventHandlers.purchaseOrderPatched = null
    this._eventHandlers.purchaseOrderItemCreated = null
    this._eventHandlers.purchaseOrderItemRemoved = null
    this._eventHandlers.purchaseOrderItemPatched = null

    /* Release quickbook events */
    this._releaseQuickbookExpenseEvents()
  }

  /* Header Functions - START */
  renderHeader () {
    const { purchaseorder } = this.data
    if (!purchaseorder) {
      return null
    }
    const pdfFileName = purchaseorder
      ? Util.getPdfFileName(
          'purchaseorder',
          purchaseorder.invoiceNo,
          purchaseorder.status
        )
      : ''
    const purchaseOrderName = purchaseorder.contact
      ? purchaseorder.contact.company
      : ''
    const downloadUrl = `${routes.PURCHASEORDER_PREVIEW}/${app.getTeamId()}/${app.loggedInId}/${purchaseorder ? purchaseorder.id : ''}/${pdfFileName}`

    const useProjectNumber = app.projectSetting.useProjectNo

    const statInfos = [
      purchaseorder.invoiceNo && {
        title: 'expense.list.labelPo',
        value: purchaseorder.invoiceNo
      },
      useProjectNumber && {
        title: 'expense.list.labelProjectNumber',
        value: purchaseorder.project ? purchaseorder.project.projectNumber : '',
        onClick: this._onHeaderOpenProject.bind(this, purchaseorder.projectId)
      },
      {
        title: 'expense.list.labelProject',
        value: purchaseorder.project ? purchaseorder.project.title : '',
        onClick: this._onHeaderOpenProject.bind(this, purchaseorder.projectId)
      }
    ].filter(Boolean)

    const rightActions = []

    const actions = []

    if (purchaseorder.status === 'Draft') {
      actions.push(
        {
          ident: 'edit',
          icon: 'edit',
          tooltip: 'estimate.view.tipEditDetails',
          tooltipPosition: 'bottom',
          onClick: this._onEdit.bind(this)
        },
        {
          ident: 'mail',
          icon: 'mail',
          tooltip: 'expense.list.tipMail',
          tooltipPosition: 'bottom',
          onClick: this._onSendMail.bind(this)
        },
        {
          ident: 'download',
          icon: 'download-solid',
          tooltip: 'expense.list.actionDownloadPdf',
          tooltipPosition: 'bottom',
          href: encodeURI(downloadUrl),
          target: '_blank'
        }
      )

      rightActions.push({
        ident: 'unlike',
        icon: purchaseorder.status === 'Draft' ? 'done' : '',
        tooltip:
          purchaseorder.status === 'Draft' ? 'expense.list.tipMarkOpen' : '',
        tooltipPosition: 'bottomright',
        size: 'big',
        type: 'success',
        onClick: this._onChangeStatus.bind(this)
      })
    } else {
      actions.push(
        {
          ident: 'mail',
          icon: 'mail',
          tooltip: 'expense.list.tipMail',
          tooltipPosition: 'bottom',
          onClick: this._onSendMail.bind(this)
        },
        {
          ident: 'download',
          icon: 'download-solid',
          tooltip: 'expense.list.actionDownloadPdf',
          tooltipPosition: 'bottom',
          href: encodeURI(downloadUrl),
          target: '_blank'
        }
      )

      rightActions.push({
        ident: 'unlike',
        icon: purchaseorder.status === 'Open' ? 'x' : 'reset',
        tooltip:
          purchaseorder.status === 'Open'
            ? 'expense.list.actionMarkClosed'
            : 'expense.list.actionReopen',
        tooltipPosition: 'bottomright',
        size: 'big',
        iconSize: '20',
        type: purchaseorder.status === 'Open' ? 'error' : 'success',
        onClick: this._onChangeStatus.bind(this)
      })
    }

    if (purchaseorder.status === 'Open') {
      rightActions.push({
        ident: 'like',
        icon: 'introduction',
        tooltip: 'expense.list.tipInvoice',
        tooltipPosition: 'bottomright',
        size: 'big',
        type: 'success',
        onClick: this._onAddPurchaseInvoice.bind(this)
      })
    }
    // Show estimate status in first
    actions.unshift({
      ident: 'status',
      type: 'button',
      title: purchaseorder.status
        ? Util.getTranslatedStatus(purchaseorder.status)
        : '',
      className: `headerstatus po_${purchaseorder.status.toLowerCase()}`
    })

    return (
      <PageHeader
        isTitleMultilingual={false}
        title={purchaseOrderName}
        icon={<ExpensesIcon width={25} />}
        statInfos={statInfos}
        alignStatInfos='bottom'
        actions={actions}
        rightActions={rightActions}
        alignActions='left'
      />
    )
  }

  _onHeaderOpenProject (purchaseorderId) {
    app.changePage('projectview-budget', purchaseorderId)
  }
  /* Header Functions - END */
}

export default PagePurchaseOrderView
